import React from "react";
import { Link, useLocation } from "react-router-dom";

export default function Layout({ children }) {
  const location = useLocation();
  const onLanding = location.pathname === "/";

  return (
    <div className="min-h-screen bg-[#F8FAFC] text-[#0F172A]">
      <header
        data-testid="site-header"
        className="sticky top-0 z-40 backdrop-blur-xl bg-white/80 border-b border-slate-200"
      >
        <div className="max-w-7xl mx-auto px-6 lg:px-10 h-28 flex items-center justify-between gap-6">
          <Link
            to="/"
            data-testid="brand-link"
            className="flex items-center gap-4 group"
            aria-label="HUB Conecta Empresarial"
          >
            <img
              src="/brand/hub-logo.webp?v=2"
              alt="HUB Conecta Empresarial"
              className="h-20 sm:h-24 w-auto rounded-lg shadow-sm"
              style={{ objectFit: "contain" }}
              data-testid="brand-logo"
            />
            <span
              data-testid="brand-tagline"
              className="hidden md:block max-w-[220px] leading-tight text-[11px] uppercase tracking-[0.18em] font-semibold text-slate-500 border-l border-slate-200 pl-4"
            >
              Diagnóstico de Desenvolvimento Empresarial HUB
            </span>
          </Link>
          {!onLanding && (
            <Link
              to="/"
              data-testid="header-back-home"
              className="text-sm text-slate-600 hover:text-slate-900"
            >
              Reiniciar
            </Link>
          )}
        </div>
      </header>
      <main>{children}</main>
      <footer className="border-t border-slate-200 mt-24 py-10 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="text-xs text-slate-500 tracking-wide">
            © {new Date().getFullYear()} HUB · Diagnóstico de Desenvolvimento Empresarial
          </div>
          <div className="text-xs text-slate-500">
            Ferramenta estratégica confidencial · Uso executivo
          </div>
        </div>
      </footer>
    </div>
  );
}
